import { Component, OnInit, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NumberPhoneQualifierService } from 'src/app/model/api-services/qualifiers/number-phone-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { SL_ID_PREFIX, SlIdContext } from 'src/app/model/directives/sl-id-context';

@Component({
  selector: 'app-number-phone-input',
  templateUrl: './number-phone-input.component.html',
  styleUrls: ['./number-phone-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    SlIdContext,
    {
      provide: SL_ID_PREFIX,
      useValue: 'attr-phone-input'
    }
  ],
})
export class NumberPhoneInputComponent extends InputComponent implements OnInit {

  public numericValue = 0;
  public numberString = '';

  set currentValue(val: any) {

    if (!val) {
      if (val !== 0) {

        this.numberString = '';
        this.numericValue = 0;
        super.currentValue = null;
        return;
      }
    }
    super.currentValue = val;
    switch (this.attribute.type) {
      case 'text':
      case 'string':
        this.numericValue = NumberPhoneQualifierService.FromString('' + val);
        break;
      default:
        this.numericValue = +val;
    }
    this.numberString = '' + this.numericValue;
  }
  get currentValue(): any {
    return super.currentValue;
  }

  SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
    super.SetAttribute(layer, attribute);
    this.currentValue = this.currentValue;
  }
  NumberChanged(value: string) {
    if (isNaN(Number(value))) {
      this.numberString = '';
      this.numericValue = 0;
      this.currentValue = 0;
      return;
    }
    this.numberString = value;
    this.numericValue = Number(this.numberString);
    if (['text', 'string'].indexOf(this.attribute.type) > -1) {
      this.currentValue = NumberPhoneQualifierService.ToString(this.numericValue, this.casting.format);
    } else {
      this.currentValue = this.numericValue;
    }
  }
  Reset() {
    this.numericValue = 0;
  }

  constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
    super(cdr);
    super._domNode = this.domNode;
  }


}
